var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/IndexSocials/IndexSocials.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/IndexSocials/IndexSocials.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "className", "isCarousel"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("className", Object.prototype.hasOwnProperty.call(kwargs, "className") ? kwargs["className"] : "");frame.set("isCarousel", Object.prototype.hasOwnProperty.call(kwargs, "isCarousel") ? kwargs["isCarousel"] : false);var t_5 = "";t_5 += "\n    ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"twitter") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"twitter")),"latest") && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"twitter")),"latest"))) || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"instagram") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"instagram")),"latest") && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"instagram")),"latest")))) {
t_5 += "\n        <div class=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "className"), env.opts.autoescape);
t_5 += "  ";
if(runtime.contextOrFrameLookup(context, frame, "isCarousel")) {
t_5 += " owl-carousel owl-theme";
;
}
t_5 += "\" >\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"twitter") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"twitter")),"latest") && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"twitter")),"latest"))) {
t_5 += "\n                <div class=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "className"), env.opts.autoescape);
t_5 += "Block\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n                    <a class=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "className"), env.opts.autoescape);
t_5 += "BlockPanel\" href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"twitter")),"latest")),0)),"url"), env.opts.autoescape);
t_5 += "\">\n                        <div class=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "className"), env.opts.autoescape);
t_5 += "BlockPanelText\"><span>";
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"twitter")),"latest")),0)),"text")), env.opts.autoescape);
t_5 += "</span></div>\n                    </a>\n                    <div class=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "className"), env.opts.autoescape);
t_5 += "BlockCaption\">\n                        ";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"twitter")),"latest")),0)),"date_humanize"), env.opts.autoescape);
t_5 += " <a href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"twitter")),"latest")),0)),"url"), env.opts.autoescape);
t_5 += "\">@";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"twitter")),"username"), env.opts.autoescape);
t_5 += "</a>\n                    </div>\n                </div>\n            ";
;
}
t_5 += "\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"instagram") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"instagram")),"latest") && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"instagram")),"latest"))) {
t_5 += "\n                ";
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"instagram")),"latest");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("item", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n                    <div class=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "className"), env.opts.autoescape);
t_5 += "Block\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n                        <a class=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "className"), env.opts.autoescape);
t_5 += "BlockPanel\" href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"url"), env.opts.autoescape);
t_5 += "\">\n                            <div class=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "className"), env.opts.autoescape);
t_5 += "BlockPanelImage\">\n                                ";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"img"), env.opts.autoescape);
t_5 += "\n                                <img src=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_9),"img")),"w920_url"), env.opts.autoescape);
t_5 += "\"\n                                    srcset=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_9),"img")),"w920_url"), env.opts.autoescape);
t_5 += " 920w,\n                                            ";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_9),"img")),"w440_url"), env.opts.autoescape);
t_5 += " 440w\"\n                                    sizes=\"(max-width: 759px) 1, ";
t_5 += "\n                                           100vw\"\n                                    alt=\"\">\n                            </div>\n                        </a>\n                        <div class=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "className"), env.opts.autoescape);
t_5 += "BlockCaption\">\n                            ";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"date_humanize"), env.opts.autoescape);
t_5 += " <a href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"url"), env.opts.autoescape);
t_5 += "\">@";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"instagram")),"username"), env.opts.autoescape);
t_5 += "</a>\n                        </div>\n                    </div>\n                ";
;
}
}
frame = frame.pop();
t_5 += "\n            ";
;
}
t_5 += "\n        </div>\n    ";
;
}
t_5 += "\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("IndexSocialsLates");
context.setVariable("IndexSocialsLates", macro_t_4);
output += "\n\n";
var macro_t_10 = runtime.makeMacro(
[], 
["data", "hasAdvertising"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("hasAdvertising", Object.prototype.hasOwnProperty.call(kwargs, "hasAdvertising") ? kwargs["hasAdvertising"] : false);var t_11 = "";t_11 += "\n    <div class=\"IndexSocials ";
if(runtime.contextOrFrameLookup(context, frame, "hasAdvertising")) {
t_11 += " IndexSocials--hasAdvertising";
;
}
t_11 += "\">\n\n\n        ";
t_11 += runtime.suppressValue((lineno = 44, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "IndexSocialsLates"), "IndexSocialsLates", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"className": "IndexSocials-latestPhone","isCarousel": true})])), env.opts.autoescape);
t_11 += "\n\n        <div class=\"IndexSocials-follow\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n            <h3>Follow ADG</h3>\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"facebook") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"facebook")),"account")) {
t_11 += "\n                <a href=\"https://www.facebook.com/";
t_11 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"facebook")),"account"), env.opts.autoescape);
t_11 += "/\">Facebook</a><br>\n            ";
;
}
t_11 += "\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"twitter") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"twitter")),"username")) {
t_11 += "\n                <a href=\"https://twitter.com/";
t_11 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"twitter")),"username"), env.opts.autoescape);
t_11 += "/\">Twitter</a><br>\n            ";
;
}
t_11 += "\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"instagram") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"instagram")),"username")) {
t_11 += "\n                <a href=\"https://www.instagram.com/";
t_11 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"instagram")),"username"), env.opts.autoescape);
t_11 += "/\">Instagram</a><br>\n            ";
;
}
t_11 += "\n        </div>\n\n        ";
t_11 += runtime.suppressValue((lineno = 59, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "IndexSocialsLates"), "IndexSocialsLates", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"className": "IndexSocials-latest","isCarousel": false})])), env.opts.autoescape);
t_11 += "\n\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_11);
});
context.addExport("IndexSocials");
context.setVariable("IndexSocials", macro_t_10);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/IndexSocials/IndexSocials.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IndexSocials/IndexSocials.jinja
// module id = 485
// module chunks = 0